import submit from "submit-form";
import PropTypes from "prop-types";
import SvgIcon from "../../../../../parts/SvgIcon";
import {
  isValidDate,
  parseUnitToShow,
} from "../../../../../utils/nutrition-util";

export const MealPlannerCalendar = ({ query, meal, day, week, viewMode }) => {
  const {
    macrosTotal = {
      calories: 0,
      carbs: 0,
      fats: 0,
      fibers: 0,
      proteins: 0,
    },
    foods,
    type,
  } = meal;
  const {
    calories: totalCalories,
    carbs: totalCarbs,
    fats: totalFats,
    proteins: totalProteins,
  } = macrosTotal;
  const hasMacrosTotal =
    totalProteins !== 0 ||
    totalCarbs !== 0 ||
    totalFats !== 0 ||
    totalCalories !== 0;

  const { date, hasData } = day;
  const { mealPlan, athlete } = query;

  const dateToUse = isValidDate(date) ? date : `Week ${week} ${date}`;

  const hasFoods = Array.isArray(foods) && foods.length > 0;

  /**
   * Delete all the foods of a meal of a day
   */
  const deleteFoodsOfMeal = () => {
    if (
      process.browser &&
      confirm(`Are you sure you want to remove all the foods of this meal?`)
    ) {
      const body = {
        indexWeek: week - 1,
        date,
        meal: type,
      };

      submit(
        `/actions/meal-planner/remove-foods-of-meal?mealPlanId=${mealPlan}&proxyAthlete=${athlete}`,
        {
          method: "POST",
          body,
        }
      );
    }
  };

  return (
    <div className="meal-planner-calendar">
      {hasData ? (
        <div
          className={`day ${hasFoods ? "day-full" : "day-empty"} ${
            viewMode ? "day-no-hover" : ""
          }`}
        >
          {!hasFoods ? (
            !viewMode && (
              <a
                href={`/actions/refresh?modal[type]=create-meal-planner-food&mealPlannerDate=${dateToUse}&mealPlannerMeal=${type}`}
                className="day-link"
              >
                <SvgIcon src="/img/new-icons/add-square-outline.svg" />
                <span>Add Food</span>
              </a>
            )
          ) : (
            <div className="day-nutrition">
              <div className="wrap-nutrition">
                {foods?.map((food, index) => {
                  const {
                    type: foodType,
                    _id,
                    quantityNumber,
                    unitOfMeasure,
                    foodId,
                  } = food;

                  if (!foodId) return null;

                  const {
                    calories = 0,
                    carbs = 0,
                    fats = 0,
                    name,
                    proteins = 0,
                    quantityDescription,
                  } = foodId;

                  return (
                    <div className="full-info" key={`${index}-${_id}`}>
                      <span className="title">{name}</span>
                      <span className="subtitle">
                        {quantityNumber}{" "}
                        {parseUnitToShow(
                          quantityNumber,
                          foodType,
                          unitOfMeasure,
                          quantityDescription
                        )}
                      </span>
                      <div className="values">
                        <div className="value">
                          <div className="protein-container">P</div>
                          <span>{proteins}</span>
                        </div>
                        <div className="value">
                          <div className="carbs-container">C</div>
                          <span>{carbs}</span>
                        </div>
                        <div className="value">
                          <div className="fat-container">F</div>
                          <span>{fats}</span>
                        </div>
                        <div className="value">
                          <div className="calories-container">K</div>
                          <span>{calories}</span>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {hasMacrosTotal && (
                  <div className="resume">
                    <div className="protein-container">{totalProteins}</div>
                    <div className="carbs-container">{totalCarbs}</div>
                    <div className="fat-container">{totalFats}</div>
                    <div className="calories-container">{totalCalories}</div>
                  </div>
                )}
              </div>
              {!viewMode && (
                <div className="action">
                  <a
                    href={`/actions/refresh?modal[type]=create-meal-planner-food&mealPlannerDate=${dateToUse}&mealPlannerMeal=${type}`}
                  >
                    <SvgIcon src={`/img/new-icons/edit-pencil.svg`} />
                    <span>Edit</span>
                  </a>
                  <button onClick={deleteFoodsOfMeal}>
                    <SvgIcon
                      src="/img/new-icons/red-trash.svg"
                      noFilterOnLight={true}
                    />
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        <div className="day !bg-[--footer-background-color]"></div>
      )}
    </div>
  );
};

MealPlannerCalendar.propTypes = {
  query: PropTypes.object,
  day: PropTypes.object,
  meal: PropTypes.object,
  week: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  viewMode: PropTypes.bool,
};
